import(/* webpackMode: "eager" */ "/vercel/path0/app/active-opportunities/page.tsx");
